import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';

export default class LocationOverviewOccupancySettingsIndexRoute extends Route {
  title = 'Occupancy Global Analytics Settings · Envoy';

  @service declare globalOverviewAccess: GlobalOverviewAccessService;
  @service declare router: RouterService;

  redirect(): void {
    if (!this.globalOverviewAccess.canVisitOccupancyGlobalSettings) {
      this.router.transitionTo('unauthorized');
    } else {
      this.router.transitionTo('location-overview.occupancy.settings');
    }
  }
}
